module.exports = __webpack_public_path__ + "c00ee28e479a4b7b9786938eeae2704b.svg";